import React from 'react'
import logo from './../../images/header-logo.svg'
export const LoginHeader = () => {
  return (
    <div className='login-header'>
        <img src={logo}/>
    </div>
  )
}
